import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orders: [],
  orderDetail: null,
};

export const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setOrderList: (state, { payload }) => {
      state.orders = payload;
    },
    detailOrder: (state, { payload }) => {
      state.orderDetail = payload;
    },
    updateOrder: (state, { payload }) => {
      if (state.orderDetail?._id === payload._id) {
        state.orderDetail = { ...state.orderDetail, ...payload };
      }
      const index = state.orders.findIndex(
        (order) => order._id === payload._id
      );
      if (index !== -1) {
        state.orders[index] = { ...state.orders[index], ...payload };
      }
    },
    deleteOrder: (state, { payload }) => {
      state.orders = state.orders.filter((order) => order._id !== payload);
      if (state.orderDetail?._id === payload) {
        state.orderDetail = null;
      }
    },
  },
});
